import { render, staticRenderFns } from "./cpd-event-form.vue?vue&type=template&id=0042a065&scoped=true&"
import script from "./cpd-event-form.vue?vue&type=script&lang=js&"
export * from "./cpd-event-form.vue?vue&type=script&lang=js&"
import style0 from "./cpd-event-form.vue?vue&type=style&index=0&id=0042a065&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042a065",
  null
  
)

export default component.exports